import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

/** WhatsApp-style full-screen profile photo viewer. Tap anywhere / Esc to close. */
export function AvatarLightbox({ src, name, onClose }) {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, onClose]);
  if (!src) return null;
  return createPortal(
    <div
      className="fixed inset-0 z-[400] bg-black/95 flex flex-col animate-in fade-in-0 duration-150"
      style={{ pointerEvents: "auto" }}
      onClick={onClose}
      onPointerDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      data-testid="avatar-lightbox"
    >
      <div className="flex items-center gap-3 px-3 pt-[max(env(safe-area-inset-top),0.75rem)] pb-3 text-white shrink-0">
        <button type="button" onClick={onClose} aria-label="close" className="h-10 w-10 rounded-full hover:bg-white/10 flex items-center justify-center" data-testid="avatar-lightbox-close">
          <X className="h-5 w-5" />
        </button>
        <div className="font-display font-semibold truncate" data-testid="avatar-lightbox-name">{name}</div>
      </div>
      <div className="flex-1 min-h-0 flex items-center justify-center p-2">
        <img src={src} alt={name || ""} className="max-h-full max-w-full object-contain animate-in zoom-in-95 duration-200" draggable={false} data-testid="avatar-lightbox-image" />
      </div>
    </div>,
    document.body,
  );
}
